import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f8f5f0'
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <div className="text-center mb-4">
              <img
                src="/Logos/logo-sin-fondo.png"
                alt="Lumière Tica"
                style={{ maxWidth: '200px', marginBottom: '20px' }}
              />
              <h2 style={{ color: '#2A2F35', fontWeight: 'bold' }}>
                Admin Panel
              </h2>
              <p style={{ color: '#555' }}>
                Ingresa tus credenciales para acceder
              </p>
            </div>

            <Card className="shadow-lg border-0">
              <Card.Body className="p-4">
                <LoginForm />
                
                <div className="text-center mt-3">
                  <p style={{ color: '#555', marginBottom: '0' }}>
                    ¿Olvidaste tu contraseña?{' '}
                    <Link
                      to="/admin/password-reset"
                      style={{
                        color: '#D4AF37',
                        textDecoration: 'none',
                        fontWeight: '500'
                      }}
                    >
                      Restablecer contraseña
                    </Link>
                  </p>
                </div>
              </Card.Body>
            </Card>

            <div className="text-center mt-3">
              <small style={{ color: '#555' }}>
                © 2026 Lumière Tica. Todos los derechos reservados.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
